import { AUTH_TOKEN } from '../constants/list';

export function storeAuthToken(authToken) {

  return {
    type: AUTH_TOKEN,
    payload: authToken
  }

}